import { onAuthStateChanged } from 'firebase/auth';
import axios from 'utils/axios';
import { auth } from '../../../firebase';
import { v4 as uuidv4 } from 'uuid';

/**
 * Runs the same anomaly sweep the scheduled job uses (Requirement 2, Phase
 * 4/6), synchronously, and returns the platform-wide snapshot: how many
 * simulations are checked, the stale ones found, and aggregate counts by
 * liveStatus and llmProvider. Response shape:
 * `{ simulationsChecked, anomalies, liveStatusCounts, providerCounts }`.
 */
const getSimulationHealthCheck = (callback, errorCallback) => {
  return async (dispatch) => {
    try {
      let unsubscribe = onAuthStateChanged(auth, async (user) => {
        const token = await user?.getIdToken();
        const reqId = uuidv4();
        try {
          const response = await axios.post(
            '/ads/admin/simulations/health-check',
            {},
            {
              params: {
                'request-id': reqId,
              },
              headers: {
                Authorization: `Bearer ${token}`,
              },
            },
          );
          if (response.status === 200) {
            if (typeof callback === 'function') callback(response?.data);
          } else {
            if (typeof errorCallback === 'function')
              errorCallback('Failed to run simulation health check');
          }
        } catch (e) {
          if (typeof errorCallback === 'function')
            errorCallback(
              e?.response?.data?.message ||
                'Failed to run simulation health check',
            );
        }
        unsubscribe();
      });
    } catch (e) {
      if (typeof errorCallback === 'function')
        errorCallback('Failed to run simulation health check');
    }
  };
};

export default getSimulationHealthCheck;
